import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Select, MenuItem, FormControl, InputLabel, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Alert, Box } from "@mui/material";
import './index.css';
import img1 from '../../../src/images/Left3.svg';
import img2 from '../../../src/images/Step 02.svg';
import img3 from '../../../src/images/cross-icon.svg';
import img4 from '../../../src/images/search-icon.svg';
import img5 from '../../../src/images/arr.svg';
import img6 from '../../../src/images/profile-ai.png'
import img7 from '../../../src/images/Gold Medal.svg'
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';
import img13 from '../../../src/images/Avatar3.svg'
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon

import config from '../../config/config';


function AIAnalysis2() {
    const navigate = useNavigate();
    const [patients, setPatients] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [filters, setFilters] = useState({
        name: '',
        riskLevel: '',
        ageRange: '',
        recentLabReports: '',
    });
    const backendURL = `${config.backendServerHost}`;

    // Fetch the list of patients from the backend API
    useEffect(() => {
    fetch(`${backendURL}/patients/api/patients`)
            .then((res) => res.json())
            .then((data) => {
                setPatients(data);
                setFilteredPatients(data);
            })
            .catch((error) => console.error('Error fetching patients:', error));
    }, []);

const handlePatientChange = (e) => {
    const patientId = e.target.value;

    if (!patientId) {
        setSelectedPatient(null);
        setFilteredPatients(patients);
        return;
    }

    const selected = patients.find((p) => String(p.id) === String(patientId));
    setSelectedPatient(selected);

    if (selected) {
        setFilteredPatients([selected]);
    }
};

    const handleFilterChange = (filterName, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [filterName]: value,
        }));
    };

    // Dynamically update filteredPatients based on filters or selectedPatient
    useEffect(() => {
        const updatedFilteredPatients = selectedPatient
            ? [selectedPatient]
            : patients.filter((patient) => {
                const matchesName =
                    !filters.name || patient.name.toLowerCase().includes(filters.name.toLowerCase());
                const matchesRisk = !filters.riskLevel || patient.riskLevel === filters.riskLevel;
                const matchesAge =
                    !filters.ageRange ||
                    (filters.ageRange === '18-25' && patient.age >= 18 && patient.age <= 25) ||
                    (filters.ageRange === '25-34' && patient.age >= 25 && patient.age <= 34) ||
                    (filters.ageRange === '35-65' && patient.age >= 35 && patient.age <= 65) ||
                    (filters.ageRange === '66+' && patient.age >= 66);
                const matchesLabReport =
                    !filters.recentLabReports || patient.labReport === filters.recentLabReports;

                return matchesName && matchesRisk && matchesAge && matchesLabReport;
            });

        setFilteredPatients(updatedFilteredPatients);
    }, [selectedPatient, filters, patients]);
    
  const navigateTo = (path, state = {}) => {
  navigate(path, { state });
};

    return (
        <div className="dashboard_container ai-analysis-container ai-analysis-container-new">
            <div className="analysis_container">
                <div className="analysis_heading">
                    <h1>Select Patient for Analysis</h1>
                    <p>1. Search for a patient</p>
                </div>

<FormControl fullWidth sx={{ mb: 2, minWidth: 250 }}>
  <InputLabel id="patient-select-label">Select a Patient</InputLabel>
  <Select
    labelId="patient-select-label"
    id="patient-select"
    value={selectedPatient?.id || ''}
    label="Select a Patient"
    onChange={handlePatientChange}
  >
    <MenuItem value="">
      <em>-- Select a Patient --</em>
    </MenuItem>
    {patients.map((patient) => (
      <MenuItem key={patient.id} value={patient.id}>
        {patient.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

                <div className="analysis_heading">
                    <h1 className='filter--heading'>Filter</h1>
                    <p>2. or / Filter from your patient list</p>
                </div>

<Box sx={{ mb: 3 }}>
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
    <FormControl fullWidth sx={{ minWidth: 200 }}>
      <InputLabel id="risk-level-label">Risk Level</InputLabel>
      <Select
        labelId="risk-level-label"
        id="risk-level"
        value={filters.riskLevel || ''}
        label="Risk Level"
        onChange={(e) => handleFilterChange('riskLevel', e.target.value)}
      >
        <MenuItem value="">
          <em>Select Risk Level</em>
        </MenuItem>
        <MenuItem value="High">High</MenuItem>
        <MenuItem value="Medium">Medium</MenuItem>
        <MenuItem value="Low">Low</MenuItem>
      </Select>
    </FormControl>
    
    <FormControl fullWidth sx={{ minWidth: 200 }}>
      <InputLabel id="age-range-label">Age Range</InputLabel>
      <Select
        labelId="age-range-label"
        id="age-range"
        value={filters.ageRange || ''}
        label="Age Range"
        onChange={(e) => handleFilterChange('ageRange', e.target.value)}
      >
        <MenuItem value="">
          <em>Select Age Range</em>
        </MenuItem>
        <MenuItem value="18-25">18-25</MenuItem>
        <MenuItem value="25-34">25-34</MenuItem>
        <MenuItem value="35-65">35-65</MenuItem>
        <MenuItem value="66+">66+</MenuItem>
      </Select>
    </FormControl>
    
    <FormControl fullWidth sx={{ minWidth: 200 }}>
      <InputLabel id="lab-reports-label">Recent Lab Reports</InputLabel>
      <Select
        labelId="lab-reports-label"
        id="lab-reports"
        value={filters.recentLabReports || ''}
        label="Recent Lab Reports"
        onChange={(e) => handleFilterChange('recentLabReports', e.target.value)}
      >
        <MenuItem value="">
          <em>Select Lab Report</em>
        </MenuItem>
        <MenuItem value="Most recent">Most recent</MenuItem>
        <MenuItem value="Recent">Recent</MenuItem>
      </Select>
    </FormControl>
  </Box>
</Box>          


<div className="analysis_heading">
    <h1 className='list-of-patient-heading'>List of Patients ({filteredPatients.length})</h1>
</div>

<div className="ai_analysis_profile_wrapper">
    {filteredPatients.length > 0 ? (
        filteredPatients.map((patient) => (
            <div
                key={patient.id}
                className="ai_analysis_profile_container"
                onClick={() =>
                    navigateTo('/patientinfo', {
                        state: {
                            patientName: patient.name,
                            patientAge: patient.age,
                            patientCondition: patient.type,
                        },
                    })
                }
                style={{ cursor: 'pointer' }} // Add a pointer cursor to indicate clickability
            >
                <div className="profile_wrapper">
                    <div>
                        <img
                            src={patient.image || img13}
                            alt={`${patient.name} Avatar`}
                        />
                    </div>
                    <div className='analysis-2-content'>
                        <h2>{patient.name}</h2>
                        <p>{patient.age} years old</p>
                        <p>Lab Report: {patient.labReport}</p>
                    </div>
                </div>
            </div>
        ))
    ) : (
        <p>No Patients Found</p>
    )}
</div>

            <div className='analysis-footer-wrapper'>
                <div className='ai-analysis-footer'>
                    <div className='ai-analysis-footer-btn' onClick={() => navigateTo('/patientinfo')}>AI Voice Command</div>
                    <p>Speak your choice (e.g., “Analyze individual patient data” or “Group trends analysis”).</p>
                </div>
            </div>

            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>


            </div>
        </div>
    );
}

export default AIAnalysis2;
